import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../../../helpers"
import { Context, Transitions } from "../../../types"

export const getAdminRelevantPlanInfoTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    loading: true
  }),
  invoke: {
    id: "getAdminRelevantPlanInfo",
    src: "getAdminRelevantPlanInfo",
    onDone: {
      target: "#StudyPlan.get_current_plan",
      actions: assign<Context, DoneInvokeEvent<any>>((_ctx, evt) => ({
        relevantDistrictPlansInfo: evt.data?.district,
        relevantSchoolPlansInfo: evt.data?.school,
        recommendedPlanId: evt.data?.recommendedPlanId,
        recommendedPlanLevel: evt.data?.recommendedPlanLevel,
        classCountRelatedToSubject: evt.data?.classCount
      }))
    },
    onError: {
      target: "#StudyPlan.study_plans_overview.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        loading: false,
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("getAdminRelevantPlanInfo", {
            messageData: ["view this list of plans"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
